export class FolderBreadcrum {
    ACCESS_TYPE: string
    ID: number
    NAME: string
    SEQUENCE_NO: number
}
